// Seitenzahlen der Seitenleiste (#223): erste und letzte Seite immer, dazu die
// Nachbarn der aktuellen; eine Luecke wird null (die Leiste zeigt „…"). Eine
// Luecke von genau einer Seite ist keine Luecke — die Zahl ist kuerzer als
// die Punkte.
const NACHBARN = 1
// Bis hierhin stehen alle Zahlen: eine Luecke spart dann nichts.
const ALLE_BIS = 7

const pageWindow = (aktuell, gesamt) => {
    if (gesamt <= ALLE_BIS) return Array.from({ length: gesamt }, (unused, i) => i + 1)

    const sichtbar = new Set([1, gesamt])
    for (let seite = aktuell - NACHBARN; seite <= aktuell + NACHBARN; seite++) {
        if (seite >= 1 && seite <= gesamt) sichtbar.add(seite)
    }

    const leiste = []
    let vorherige = 0
    for (const seite of [...sichtbar].sort((a, b) => a - b)) {
        if (seite - vorherige === 2) leiste.push(seite - 1)
        else if (seite - vorherige > 2) leiste.push(null)
        leiste.push(seite)
        vorherige = seite
    }
    return leiste
}

export default pageWindow
